var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ComingSoonFeatureVote',{attrs:{"title":_vm.$t('broker.onevsone.duels'),"description":_vm.$t('broker.onevsone.oneVsOneDescription'),"image-src":_vm.imageSrc,"feature-name":"COMING_FEATURE_DUELS1VS1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }